import classNames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import React from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { Editor } from '@meitu/saas-editor-core/es/index';
import { IImageLayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n/index';
import { getEmptyEffect, getPresetEffectList } from '../../constant';
import { useActiveData } from '../../hook';
import './image-effect-list.less';
import { ImageLayer } from '@meitu/saas-editor-core/es/layers/image-layer';

const ImageEffectList: React.FC<{
    effectListClickStatTrack: Function;
    funcStatTrack: Function;
    editor: Editor;
    theme: string;
    scrollHeight?: number;
    excludeIndexs?: number[];
}> = ({ effectListClickStatTrack, funcStatTrack, editor, theme, scrollHeight = 260, excludeIndexs }) => {
    const { $t } = useLocaleStore();
    const { activeLayer, setActiveData } = useActiveData();
    if (!activeLayer || activeLayer.layerType !== LayerType.IMAGE_LAYER) return null;

    let currentSelectId = -1;
    const { data } = activeLayer;
    const { effect } = data as IImageLayerProps;
    const effectList = getPresetEffectList(theme);
    if (!effect) {
        currentSelectId = -1;
    } else {
        const index = effectList.findIndex(
            (item) =>
                `${JSON.stringify(item.effect.shadow)}${JSON.stringify(
                    item.effect.stroke,
                )}${JSON.stringify(item.effect.glow)}` ===
                `${JSON.stringify(effect.shadow)}${JSON.stringify(effect.stroke)}${JSON.stringify(effect.glow)}`,
        );
        if (index === -1) {
            currentSelectId = -1;
        } else {
            currentSelectId = effectList[index].id;
        }
    }

    const removeAllEffect = () => {
        const preLayer = cloneDeep(activeLayer);
        const imageData = activeLayer.data as IImageLayerProps;
        imageData.effect = getEmptyEffect();
        const newLayer = cloneDeep(activeLayer);
        editor.getInstance(ImageLayer).changeImageEffectAttr(newLayer, undefined, 'effectClick', true, preLayer);
        setActiveData(newLayer);
    };

    const effectClick = (effect: any, index: number) => {
        const preLayer = cloneDeep(activeLayer);
        const imageData = activeLayer.data as IImageLayerProps;
        imageData.effect = effect;
        const newLayer = cloneDeep(activeLayer);
        editor.getInstance(ImageLayer).changeImageEffectAttr(newLayer, undefined, 'effectClick', false, preLayer);
        setActiveData(newLayer);
        effectListClickStatTrack(index);
        funcStatTrack({
            clickId: 48,
            useId: 48,
        });
    };

    return (
        <div className="c-image-panel-effect-list">
            <Scrollbars autoHide autoHeight autoHeightMax={scrollHeight}>
                <div className="inner">
                    <div
                        className={classNames({
                            'effect-item': true,
                            remove: true,
                            active: currentSelectId === -1,
                        })}
                        onClick={() => {
                            removeAllEffect();
                        }}
                    >
                        <IconFont name="SlashCircleBold" fontSize={28} />
                    </div>

                    {getPresetEffectList(theme)
                        .filter((_item, index) => !excludeIndexs || !excludeIndexs.includes(index))
                        .map((item, index) => {
                            return (
                                <div
                                    key={item.id}
                                    className={classNames({
                                        'effect-item': true,
                                        active: currentSelectId === item.id,
                                    })}
                                    onClick={() => {
                                        effectClick(item.effect, index);
                                    }}
                                >
                                    <img
                                        width="100%"
                                        height="100%"
                                        src={item.url}
                                        alt={$t((v) => v.imageEffectPanel.effect)}
                                    />
                                </div>
                            );
                        })}
                </div>
            </Scrollbars>
        </div>
    );
};

export default ImageEffectList;
